<template>
  <div class="pagination-wrap"  v-if="items.total_records > items.per_page">
      <div class="page-record" v-if="from && to && total && showPageRecord">
        <span>Showing {{ from }} to {{ to }} of {{ total }} results</span>
      </div>
      <div class="table-pagination mb-2">
        <b-pagination
            v-if="items.total_records > 0"
            v-model="items.current_page"
            :total-rows="items.total_records"
            :per-page="items.per_page"
            class="mt-4"
            prev-text="Prev"
            next-text="Next"
            first-text="First"
            last-text="Last"
            @change="handlePageChange"

        >
        </b-pagination>
      </div>
  </div>
</template>

<script>
import Helper from "@/resource/Helper";
import axios from "axios";
export default {
  name: "Pagination",
  props: {
    rows: {
      required: true,
    },
    filters: {
      default() {
        return {};
      },
    },
    showPageRecord: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    perPage() {
      return this.items.per_page ? this.items.per_page : 10;
    },
    filterQuery() {
      return Helper.objToUrlParams(this.filterParams);
    },
    from() {
      return this.items.record_range ? this.items.record_range[0] : "";
    },
    to() {
      return this.items.record_range ? this.items.record_range[1] : "";
    },
    total() {
      return this.items.total_records ? this.items.total_records : "";
    },
  },
  data() {
    return {
      items: [],
      filterParams: {},
    };
  },
  methods: {
    handlePageChange(page) {
      let url;
      url = `${this.items.path}?page_size=${this.items.per_page}&page=${page}`;
      this.getData(url);
    },
    // goToUrl(url) {
    //   if (this.filterQuery) {
    //     url = url + `&${this.filterQuery}`;
    //   }
    //   this.getData(url);
    // },
    async getData(url) {
      if (this.filterQuery) {
        url = `${url}&${this.filterQuery}`;
      }
      let loader = this.$loading.show();
      await axios
        .get(url)
        .then((response) => {
          let data = response.data;
          this.$emit("update:rows", data);
        })
        .catch((error) => {
          console.log("error");
        })
        .finally(() => {
          loader.hide();
        });
    },
  },

  created() {
    this.items = this.rows;
    this.filterParams = this.filters;
  },
  watch: {
    rows(value) {
      this.items = value;
    },
    filters(value) {
      this.filterParams = value;
    },
  },
};
</script>

<style>
.pagination{
  display: block;
}
.pagination .page-item{
  display: inline-block;
}

.page-record {
  font-size: 14px;
}

.pagination-wrap {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pagination-wrap .page-item.active .page-link {
  background-color: #ffffff !important;
  color: #778699 !important;
}
</style>
